import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {Customer} from '../../model/Entities/Customer';
import {ContractItem} from '../../model/Entities/ContractItem';

@Component({
    selector: 'contract-item-split-dialog',
    templateUrl: './contract-item-split.dialog.component.html',
    styleUrls: ['./contract-item-split.dialog.component.scss']
})
export class ContractItemSplitDialogComponent {

    item: ContractItem;

    constructor(public dialog: MatDialogRef<ContractItemSplitDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any) {
        this.item = data.item;
    }
}



// WEBPACK FOOTER //
// /app/src/ContractsModule/ContractItemSplitDialogComponent/contract-item-split.dialog.component.ts